module.exports = __webpack_public_path__ + "img/column-furniture.2f687d2.svg";